const privacyGR = {
  title: "Πολιτική Απορρήτου",
  effectiveDate: "14 Οκτωβρίου 2026",
  intro: `Η EnQube ΙΚΕ ("Εταιρεία", "εμείς", "μας"), η οποία εδρεύει στην Πάτρα, Ελλάδα, λειτουργεί την πλατφόρμα Agapaé (την "Πλατφόρμα"). Δεσμευόμαστε για την προστασία των προσωπικών σας δεδομένων και τον σεβασμό του απορρήτου σας.

Η παρούσα Πολιτική Απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε, αποθηκεύουμε και μοιραζόμαστε τα προσωπικά σας δεδομένα κατά τη χρήση της Πλατφόρμας μας, σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ) 2016/679 ("GDPR") και την εφαρμοστέα ελληνική νομοθεσία περί προστασίας δεδομένων.`,

  sections: [
    {
      heading: "1. Υπεύθυνος Επεξεργασίας",
      content: [
        `Υπεύθυνος επεξεργασίας των προσωπικών δεδομένων που επεξεργάζεται η Πλατφόρμα είναι:`,
        {
          type: "list",
          items: [
            `Εταιρεία: EnQube ΙΚΕ`,
            `Έδρα: Πάτρα, Ελλάδα`,
            `Email: privacy@agapae.gr`,
          ],
        },
        `Στις περιπτώσεις που ένα Ζευγάρι (Διοργανωτής Εκδήλωσης) καθορίζει τους σκοπούς και τα μέσα επεξεργασίας δεδομένων Καλεσμένων, το Ζευγάρι ενεργεί ως υπεύθυνος επεξεργασίας και η EnQube ΙΚΕ ενεργεί ως εκτελούσα την επεξεργασία. Δείτε την Ενότητα 6 για περισσότερες λεπτομέρειες.`,
      ],
    },
    {
      heading: "2. Δεδομένα που Συλλέγουμε",
      content: [
        `Συλλέγουμε τις ακόλουθες κατηγορίες προσωπικών δεδομένων:`,
        {
          type: "emphasis",
          text: "Δεδομένα Λογαριασμού",
        },
        `Κατά τη δημιουργία λογαριασμού ως Ζευγάρι, συλλέγουμε τη διεύθυνση email και τον κωδικό πρόσβασής σας (ο οποίος αποθηκεύεται με μη αναστρέψιμη κρυπτογραφική κατακερματοποίηση (hash) και ουδέποτε σε απλό κείμενο). Συλλέγουμε επίσης το όνομα και την ημερομηνία της εκδήλωσης.`,
        {
          type: "emphasis",
          text: "Δεδομένα Εκδήλωσης",
        },
        `Πληροφορίες που παρέχετε για τον γάμο ή την εκδήλωσή σας, περιλαμβανομένων: ονομάτων συντρόφων, αριθμών τηλεφώνου, ημερομηνίας και τοποθεσίας εκδήλωσης, στοιχείων χώρου τελετής και δεξίωσης (περιλαμβανομένων συνδέσμων χάρτη), προγράμματος, αφηγήσεων ιστορίας αγάπης, ονομάτων μελών οικογένειας και κουμπάρων, καθώς και προτιμήσεων δώρων, περιλαμβανομένων τραπεζικών στοιχείων (IBAN, όνομα δικαιούχου λογαριασμού) και διαδικτυακής διεύθυνσης μητρώου δώρων, εφόσον παρέχονται.`,
        {
          type: "emphasis",
          text: "Δεδομένα Καλεσμένων",
        },
        `Όταν οι Καλεσμένοι συμμετέχουν σε εκδήλωση, συλλέγουμε το όνομά τους όπως επιθυμούν να εμφανίζεται και, εφόσον απαιτείται από το Ζευγάρι, τη διεύθυνση email τους. Σε κάθε Καλεσμένο αποδίδεται ένα αδιαφανές αναγνωριστικό ανά εκδήλωση (για παράδειγμα, "guest-" ακολουθούμενο από τυχαία αλφαριθμητική ακολουθία), το οποίο μας επιτρέπει να αποδίδουμε τις μεταφορτώσεις περιεχομένου χωρίς να εκθέτουμε την πραγματική ταυτότητα στους λοιπούς χρήστες. Καταγράφουμε επίσης το χρονικό σημείο συμμετοχής τους στην εκδήλωση.`,
        {
          type: "emphasis",
          text: "Δεδομένα Λίστας Καλεσμένων (που εισάγονται από το Ζευγάρι)",
        },
        `Τα Ζευγάρια μπορούν να δημιουργήσουν λίστα καλεσμένων εντός της Πλατφόρμας. Για κάθε προσκεκλημένο, το Ζευγάρι μπορεί να εισαγάγει στοιχεία επικοινωνίας (όνομα, email, τηλέφωνο), σύνθεση παρέας, κατάσταση RSVP και, προαιρετικά, διατροφικές προτιμήσεις (για παράδειγμα, χορτοφαγική, χωρίς γλουτένη) και σημειώσεις προσβασιμότητας ή ειδικής υποστήριξης — αποκλειστικά για να διευκολυνθεί ο συντονισμός εστίασης και φιλοξενίας. Το Ζευγάρι είναι ο υπεύθυνος επεξεργασίας αυτών των πληροφοριών· εμείς τις επεξεργαζόμαστε για λογαριασμό του Ζευγαριού ως εκτελούσα την επεξεργασία (δείτε Ενότητες 6 και 7).`,
        `Τα Ζευγάρια σε κατάλληλα πακέτα μπορούν επίσης να οργανώσουν τους Καλεσμένους σε τραπέζια για τη δεξίωση και, προαιρετικά, να ενεργοποιήσουν μια αναζήτηση θέσης ώστε κάθε Καλεσμένος να βρίσκει το τραπέζι του — και, εφόσον το επιτρέψει το Ζευγάρι, να βλέπει ποιοι άλλοι κάθονται μαζί του. Οι διατάξεις αυτές αποτελούν μέρος των Δεδομένων Λίστας Καλεσμένων που αναφέρονται παραπάνω και ακολουθούν τους ίδιους ρόλους υπευθύνου/εκτελούντος την επεξεργασία και τους ίδιους κανόνες διατήρησης.`,
        {
          type: "emphasis",
          text: "Δεδομένα Πολυμέσων",
        },
        `Φωτογραφίες και βίντεο που ανεβαίνουν από Ζευγάρια ή Καλεσμένους, μαζί με τα σχετικά μεταδεδομένα όπως αρχικό όνομα αρχείου, μέγεθος, τύπο περιεχομένου (MIME), διαστάσεις εικόνας, διάρκεια βίντεο και κατάσταση επεξεργασίας.`,
        {
          type: "emphasis",
          text: "Οικονομικά Δεδομένα",
        },
        `Για πληρωμένα Πακέτα Υπηρεσίας, αποθηκεύουμε το Stripe customer ID, subscription ID, payment intent ID, τύπο πακέτου, κατάσταση συνδρομής και ημερομηνίες πληρωμής. Δεν αποθηκεύουμε στοιχεία πληρωτικών καρτών — η επεξεργασία καρτών γίνεται αποκλειστικά από τη Stripe, έναν πάροχο πληρωμών συμβατό με PCI-DSS.`,
        {
          type: "emphasis",
          text: "Δεδομένα Επικοινωνίας",
        },
        `Εάν χρησιμοποιήσετε τη φόρμα επικοινωνίας, συλλέγουμε το όνομα, επώνυμο, email, θέμα και περιεχόμενο μηνύματός σας. Εάν εγγραφείτε στο newsletter, συλλέγουμε τη διεύθυνση email σας.`,
        {
          type: "emphasis",
          text: "Τεχνικά Δεδομένα",
        },
        `Συλλέγουμε διευθύνσεις IP ως μέρος του συστήματος καταγραφής ελέγχου (audit logging), το οποίο καταγράφει δραστηριότητες μεταφόρτωσης, συμβάντα αποθηκευτικού χώρου και διαγραφές πολυμέσων. Συλλέγουμε επίσης τυπικά αρχεία καταγραφής διακομιστή απαραίτητα για την ασφάλεια και τη λειτουργία της υπηρεσίας.`,
        {
          type: "emphasis",
          text: "Δεδομένα Βοηθού AI",
        },
        `Σε κατάλληλα πακέτα (Heirloom), τα Ζευγάρια μπορούν να χρησιμοποιήσουν τον Ἔρως, τον προαιρετικό βοηθό AI για την οργάνωση. Όταν αλληλεπιδράτε με τον Ἔρως, επεξεργαζόμαστε τα μηνύματα που του στέλνετε, μαζί με τα Δεδομένα Εκδήλωσης και τα Δεδομένα Λίστας Καλεσμένων που χρειάζεται για να σας απαντήσει — για παράδειγμα τη λίστα καλεσμένων, τις εργασίες, τους συνεργάτες, τις πληρωμές, τον προϋπολογισμό, τη διάταξη των τραπεζιών, το πρόγραμμα και τα στοιχεία της πρόσκλησης — αποκλειστικά για την παραγωγή των απαντήσεων του βοηθού εντός της δικής σας εκδήλωσης. Δείτε την Ενότητα 5 για τους παρόχους AI που εμπλέκονται.`,
      ],
    },
    {
      heading: "3. Νομικές Βάσεις Επεξεργασίας",
      content: [
        `Επεξεργαζόμαστε τα προσωπικά σας δεδομένα στις ακόλουθες νομικές βάσεις του Άρθρου 6 του GDPR:`,
        {
          type: "emphasis",
          text: "Εκτέλεση Σύμβασης (Άρθ. 6(1)(β))",
        },
        `Επεξεργαζόμαστε Δεδομένα Λογαριασμού, Εκδήλωσης, Καλεσμένων και Πολυμέσων εφόσον είναι αναγκαία για την εκτέλεση της σύμβασης που μας συνδέει μαζί σας — ήτοι για την παροχή της υπηρεσίας Agapaé, τη διαχείριση της εκδήλωσής σας, τη φιλοξενία πολυμέσων και την παράδοση των χαρακτηριστικών του Πακέτου Υπηρεσίας σας.`,
        {
          type: "emphasis",
          text: "Έννομο Συμφέρον (Άρθ. 6(1)(στ))",
        },
        `Επεξεργαζόμαστε Τεχνικά Δεδομένα (διευθύνσεις IP και αρχεία ελέγχου) για παρακολούθηση ασφαλείας, πρόληψη απάτης, ανίχνευση κατάχρησης και ακεραιότητα υπηρεσίας. Χρησιμοποιούμε επίσης συγκεντρωτικά, μη αναγνωρίσιμα δεδομένα για βελτίωση της υπηρεσίας. Τα έννομα συμφέροντά μας δεν υπερισχύουν των θεμελιωδών δικαιωμάτων και ελευθεριών σας.`,
        {
          type: "emphasis",
          text: "Συγκατάθεση (Άρθ. 6(1)(α))",
        },
        `Επεξεργαζόμαστε τη διεύθυνση email σας για ενημερωτικά δελτία βάσει ρητής συγκατάθεσής σας, που λαμβάνεται μέσω διαδικασίας διπλής επιβεβαίωσης. Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Όπου ισχύει, λαμβάνουμε συγκατάθεση για μη αναγκαία cookies, όπως περιγράφεται στην Πολιτική για τα Cookies μας.`,
        {
          type: "emphasis",
          text: "Νομική Υποχρέωση (Άρθ. 6(1)(γ))",
        },
        `Ενδέχεται να επεξεργαστούμε Οικονομικά Δεδομένα για συμμόρφωση με φορολογικές, λογιστικές και ρυθμιστικές υποχρεώσεις βάσει ελληνικής και ευρωπαϊκής νομοθεσίας.`,
      ],
    },
    {
      heading: "4. Πώς Χρησιμοποιούμε τα Δεδομένα σας",
      content: [
        `Χρησιμοποιούμε τα προσωπικά σας δεδομένα για τους ακόλουθους σκοπούς:`,
        {
          type: "list",
          items: [
            `Δημιουργία και διαχείριση του λογαριασμού σας και έλεγχος ταυτότητας για την πρόσβαση σε αυτόν·`,
            `Παροχή και συντήρηση της υπηρεσίας διαχείρισης γαμήλιων εκδηλώσεων·`,
            `Φιλοξενία, επεξεργασία και παράδοση φωτογραφιών και βίντεο (συμπεριλαμβανομένης δημιουργίας μικρογραφιών και μετατροπής βίντεο)·`,
            `Ενεργοποίηση δυνατότητας Καλεσμένων να βλέπουν πληροφορίες εκδήλωσης και να συνεισφέρουν πολυμέσα·`,
            `Επεξεργασία πληρωμών και διαχείριση του Πακέτου Υπηρεσίας σας·`,
            `Αποστολή συναλλακτικών email (επαλήθευση λογαριασμού, επαναφορά κωδικού, επιβεβαιώσεις πληρωμής)·`,
            `Αποστολή ενημερωτικών δελτίων (με τη συγκατάθεσή σας)·`,
            `Απάντηση σε ερωτήματα μέσω φόρμας επικοινωνίας·`,
            `Παροχή του προαιρετικού βοηθού AI για την οργάνωση (Ἔρως) σε κατάλληλα πακέτα·`,
            `Παρακολούθηση και διασφάλιση ασφάλειας και ακεραιότητας της υπηρεσίας·`,
            `Συμμόρφωση με νομικές υποχρεώσεις.`,
          ],
        },
        `Ο βοηθός AI Ἔρως παρέχει προτάσεις τις οποίες εσείς αποφασίζετε αν θα ακολουθήσετε· δεν προβαίνει σε αυτοματοποιημένη λήψη αποφάσεων που παράγει έννομα αποτελέσματα ή σας επηρεάζει σημαντικά κατά ανάλογο τρόπο, κατά την έννοια του Άρθρου 22 GDPR, ούτε σε κατάρτιση προφίλ (profiling). Δεν πωλούμε τα προσωπικά σας δεδομένα σε τρίτα μέρη.`,
      ],
    },
    {
      heading: "5. Κοινοποίηση Δεδομένων και Εκτελούντες την Επεξεργασία",
      content: [
        `Διαβιβάζουμε τα προσωπικά σας δεδομένα στους ακόλουθους τρίτους παρόχους υπηρεσιών (εκτελούντες την επεξεργασία και υπο-εκτελούντες), έκαστος εκ των οποίων επεξεργάζεται δεδομένα για λογαριασμό μας:`,
        {
          type: "table",
          headers: [
            "Πάροχος",
            "Σκοπός",
            "Δεδομένα",
            "Τοποθεσία",
          ],
          rows: [
            [
              "Stripe",
              "Επεξεργασία πληρωμών",
              "Email, αναγνωριστικό εκδήλωσης, στοιχεία πακέτου",
              "ΗΠΑ (Τυποποιημένες Συμβατικές Ρήτρες / Data Privacy Framework)",
            ],
            [
              "Amazon Web Services (S3)",
              "Αποθήκευση πολυμέσων",
              "Φωτογραφίες, βίντεο, μικρογραφίες",
              "ΕΕ (Φρανκφούρτη, eu-central-1)",
            ],
            [
              "Amazon Web Services (MediaConvert, Lambda)",
              "Μετατροπή βίντεο και επεξεργασία εικόνων",
              "Αρχεία βίντεο και εικόνων",
              "ΕΕ (Φρανκφούρτη, eu-central-1)",
            ],
            [
              "MongoDB Atlas",
              "Φιλοξενία βάσης δεδομένων",
              "Όλα τα δεδομένα εφαρμογής",
              "ΕΕ",
            ],
            [
              "Resend",
              "Αποστολή συναλλακτικών email",
              "Διευθύνσεις email, περιεχόμενο email",
              "ΗΠΑ (Τυποποιημένες Συμβατικές Ρήτρες / Data Privacy Framework)",
            ],
            [
              "Google Cloud Run",
              "Φιλοξενία API",
              "Δεδομένα αιτημάτων σε μεταφορά",
              "ΕΕ (Βέλγιο, europe-west1)",
            ],
            [
              "Google Fonts",
              "Παράδοση γραμματοσειρών",
              "Διεύθυνση IP (τυπική αίτηση δικτύου)",
              "Παγκόσμιο CDN",
            ],
            [
              "Sentry (Functional Software, Inc.)",
              "Παρακολούθηση σφαλμάτων εφαρμογής",
              "Διεύθυνση IP, πλαίσιο σφάλματος, αναγνωριστικό χρήστη και email όταν είναι συνδεδεμένος",
              "ΗΠΑ (Τυποποιημένες Συμβατικές Ρήτρες)",
            ],
            [
              "Cloudflare Turnstile",
              "Προστασία από αυτοματοποιημένα προγράμματα (bots) σε φόρμες εγγραφής, RSVP και επικοινωνίας",
              "Διεύθυνση IP, χαρακτηριστικά αναγνώρισης του προγράμματος περιήγησης (fingerprint)",
              "Παγκόσμιο CDN (Τυποποιημένες Συμβατικές Ρήτρες)",
            ],
            [
              "Anthropic, PBC (Claude)",
              "Απαντήσεις βοηθού AI για την οργάνωση (Heirloom)",
              "Δεδομένα εκδήλωσης και οργάνωσης που υποβάλλετε στον βοηθό",
              "ΗΠΑ (Τυποποιημένες Συμβατικές Ρήτρες)",
            ],
            [
              "Google (Gemini API / Google AI Studio)",
              "Απαντήσεις βοηθού AI για την οργάνωση (Heirloom)",
              "Δεδομένα εκδήλωσης και οργάνωσης που υποβάλλετε στον βοηθό",
              "ΗΠΑ (Τυποποιημένες Συμβατικές Ρήτρες / Data Privacy Framework)",
            ],
          ],
        },
        `Απαιτούμε από όλους τους εκτελούντες την επεξεργασία και τους υπο-εκτελούντες να εφαρμόζουν κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των δεδομένων σας, σύμφωνα με το άρθρο 28 του GDPR.`,
        `Οι πάροχοι AI που αναφέρονται παραπάνω (Anthropic και Google) επεξεργάζονται τα δεδομένα που υποβάλλετε στον βοηθό αποκλειστικά για την παραγωγή των απαντήσεών του. Βάσει των όρων που ισχύουν για τις επιχειρηματικές υπηρεσίες και τα API τους, δεν χρησιμοποιούν αυτά τα δεδομένα για την εκπαίδευση των μοντέλων τους, ενώ διατηρούμε με καθέναν από αυτούς όρους επεξεργασίας δεδομένων.`,
        `Δεν διαβιβάζουμε τα προσωπικά σας δεδομένα σε άλλα τρίτα μέρη, εκτός εάν απαιτείται από τη νομοθεσία ή κατόπιν της ρητής συγκατάθεσής σας.`,
      ],
    },
    {
      heading: "6. Απόρρητο Καλεσμένων και Ρόλοι Δεδομένων",
      content: [
        `Η Πλατφόρμα μας διαθέτει ιδιαίτερη δομή ρόλων επεξεργασίας δεδομένων, την οποία θέλουμε να σας εξηγήσουμε με σαφήνεια.`,
        {
          type: "emphasis",
          text: "Όταν το Ζευγάρι είναι Υπεύθυνος Επεξεργασίας",
        },
        `Όταν ένα Ζευγάρι εισάγει προσωπικά δεδομένα σχετικά με τους Καλεσμένους του (όπως ονόματα και email), το Ζευγάρι ενεργεί ως υπεύθυνος επεξεργασίας. Το Ζευγάρι καθορίζει γιατί και πώς επεξεργάζονται αυτά τα δεδομένα. Η EnQube ΙΚΕ ενεργεί ως εκτελούσα την επεξεργασία, επεξεργαζόμενη δεδομένα Καλεσμένων αποκλειστικά για την παροχή της Υπηρεσίας.`,
        {
          type: "emphasis",
          text: "Όταν η EnQube ΙΚΕ είναι Υπεύθυνος Επεξεργασίας",
        },
        `Για δεδομένα Καλεσμένων που συλλέγουμε απευθείας — όπως όταν ένας Καλεσμένος συμμετέχει σε εκδήλωση και παρέχει το όνομα και email του, ή ανεβάζει πολυμέσα — η EnQube ΙΚΕ ενεργεί ως υπεύθυνος επεξεργασίας.`,
        {
          type: "emphasis",
          text: "Δικαιώματα Καλεσμένων",
        },
        `Οι Καλεσμένοι, ανεξάρτητα αν διαθέτουν εγγεγραμμένο λογαριασμό, έχουν τα ίδια δικαιώματα προστασίας δεδομένων με κάθε υποκείμενο δεδομένων βάσει GDPR (δείτε Ενότητα 10). Οι Καλεσμένοι μπορούν να ασκήσουν τα δικαιώματά τους επικοινωνώντας μαζί μας στο privacy@agapae.gr ή επικοινωνώντας με το Ζευγάρι που τους προσκάλεσε, όταν το Ζευγάρι είναι ο υπεύθυνος επεξεργασίας.`,
        `Οι Καλεσμένοι μπορούν να ανεβάσουν Περιεχόμενο στην κοινόχρηστη γκαλερί μιας εκδήλωσης. Αυτό το Περιεχόμενο υπόκειται στις ίδιες πολιτικές αποθήκευσης, διατήρησης και διαγραφής με όλα τα Δεδομένα Εκδήλωσης.`,
      ],
    },
    {
      heading: "7. Ειδικές Κατηγορίες Δεδομένων",
      content: [
        `Η Πλατφόρμα έχει σχεδιαστεί ώστε να ελαχιστοποιεί τη συλλογή ειδικών κατηγοριών προσωπικών δεδομένων όπως ορίζονται στο Άρθρο 9 του GDPR (δεδομένα που αποκαλύπτουν φυλετική ή εθνοτική καταγωγή, πολιτικά φρονήματα, θρησκευτικές ή φιλοσοφικές πεποιθήσεις, συνδικαλιστική ένταξη, γενετικά δεδομένα, βιομετρικά δεδομένα, δεδομένα υγείας ή δεδομένα σεξουαλικής ζωής ή σεξουαλικού προσανατολισμού).`,
        {
          type: "emphasis",
          text: "Διατροφικές Προτιμήσεις και Σημειώσεις Ειδικής Υποστήριξης",
        },
        `Τα Ζευγάρια μπορούν, κατά τη διακριτική τους ευχέρεια, να εισάγουν διατροφικές προτιμήσεις (για παράδειγμα, χορτοφαγική, χωρίς γλουτένη, halal, kosher) και σημειώσεις ειδικής υποστήριξης ή προσβασιμότητας για μεμονωμένους Καλεσμένους στη λίστα τους. Μέρος αυτών των πληροφοριών ενδέχεται να αποκαλύπτει έμμεσα θρησκευτικές πεποιθήσεις ή καταστάσεις υγείας και, ως εκ τούτου, χαρακτηρίζονται ως ειδική κατηγορία δεδομένων κατά το Άρθρο 9 GDPR.`,
        `Για αυτή την κατηγορία δεδομένων, το Ζευγάρι ενεργεί ως υπεύθυνος επεξεργασίας και η EnQube ΙΚΕ ενεργεί ως εκτελούσα την επεξεργασία (δείτε Ενότητα 6). Το Ζευγάρι είναι υπεύθυνο για τη λήψη της ρητής συγκατάθεσης του Καλεσμένου (Άρθ. 9(2)(α) GDPR), όπου απαιτείται από τη νομοθεσία, πριν εισαγάγει τέτοιες πληροφορίες στην Πλατφόρμα. Επεξεργαζόμαστε αυτά τα δεδομένα αποκλειστικά για να εμφανίζονται στο Ζευγάρι και στους εξουσιοδοτημένους συνεργάτες του, με σκοπό τον συντονισμό της εστίασης και της φιλοξενίας κατά την εκδήλωση. Δεν τα χρησιμοποιούμε για κανέναν άλλο σκοπό.`,
        `Όταν διατροφικές σημειώσεις ή σημειώσεις ειδικής υποστήριξης ενός Καλεσμένου αποτελούν μέρος των πληροφοριών που διαβάζει ο βοηθός AI Ἔρως για να απαντήσει σε αίτημα του Ζευγαριού, τα δεδομένα αυτά ενδέχεται να διαβιβαστούν στους παρόχους AI που αναφέρονται στην Ενότητα 5, υπό τους ίδιους ρόλους υπευθύνου/εκτελούντος την επεξεργασία και τους ίδιους περιορισμένους όρους — αποκλειστικά για την παραγωγή της ζητούμενης απάντησης και ποτέ για την εκπαίδευση οποιουδήποτε μοντέλου.`,
        `Οι Καλεσμένοι μπορούν ανά πάσα στιγμή να ζητήσουν τη διόρθωση ή τη διαγραφή διατροφικών σημειώσεων ή σημειώσεων ειδικής υποστήριξης που τους αφορούν, είτε επικοινωνώντας απευθείας με το Ζευγάρι είτε γράφοντας στο privacy@agapae.gr (δείτε Ενότητα 10).`,
        `Εάν μελλοντικά χαρακτηριστικά της Πλατφόρμας απαιτήσουν την άμεση συλλογή οποιωνδήποτε άλλων ειδικών κατηγοριών δεδομένων, θα λάβουμε τη ρητή συγκατάθεσή σας (Άρθ. 9(2)(α) GDPR) πριν την επεξεργασία και θα εξηγήσουμε ξεκάθαρα τον σκοπό και το πεδίο εφαρμογής.`,
      ],
    },
    {
      heading: "8. Διατήρηση Δεδομένων",
      content: [
        `Διατηρούμε τα προσωπικά σας δεδομένα μόνο για όσο χρειάζεται για την εκπλήρωση των σκοπών συλλογής τους:`,
        {
          type: "table",
          headers: ["Κατηγορία Δεδομένων", "Περίοδος Διατήρησης"],
          rows: [
            [
              "Δεδομένα Λογαριασμού",
              "Διάρκεια λογαριασμού, συν 30 ημέρες μετά το αίτημα διαγραφής",
            ],
            [
              "Δεδομένα Εκδήλωσης και Πολυμέσα",
              "Ανά Πακέτο: Blossom 15 ημέρες, Bouquet 60 ημέρες, Heirloom 90 ημέρες μετά την εκδήλωση",
            ],
            [
              "Αρχεία Ελέγχου",
              "Διατηρούνται με τα σχετικά Δεδομένα Εκδήλωσης, διαγράφονται στο ίδιο χρονοδιάγραμμα",
            ],
            [
              "Οικονομικά Δεδομένα",
              "Όπως απαιτείται από την ελληνική φορολογική νομοθεσία (έως 5 έτη)",
            ],
            [
              "Εγγραφές Newsletter",
              "Μέχρι τη διαγραφή εγγραφής ή ανάκληση συγκατάθεσης",
            ],
            [
              "Μηνύματα Φόρμας Επικοινωνίας",
              "12 μήνες μετά την υποβολή",
            ],
            [
              "Προτιμήσεις Συγκατάθεσης Cookies",
              "1 έτος (αποθηκεύεται στο cookie του προγράμματος περιήγησης)",
            ],
          ],
        },
        `Μετά τη λήξη της περιόδου διατήρησης, τα δεδομένα διαγράφονται οριστικά από τα συστήματά μας, περιλαμβανομένου του αποθηκευτικού χώρου υπολογιστικού νέφους (cloud). Η διαδικασία αυτή είναι μη αναστρέψιμη.`,
      ],
    },
    {
      heading: "9. Διεθνείς Διαβιβάσεις Δεδομένων",
      content: [
        `Το μεγαλύτερο μέρος των δεδομένων σας επεξεργάζεται εντός της Ευρωπαϊκής Ένωσης:`,
        {
          type: "list",
          items: [
            `Αποθήκευση και επεξεργασία πολυμέσων: AWS eu-central-1 (Φρανκφούρτη, Γερμανία)`,
            `Φιλοξενία API: Google Cloud europe-west1 (Βέλγιο)`,
            `Βάση δεδομένων: MongoDB Atlas (Περιοχή ΕΕ)`,
          ],
        },
        `Ορισμένοι εκτελούντες την επεξεργασία εδρεύουν στις Ηνωμένες Πολιτείες:`,
        {
          type: "list",
          items: [
            `Stripe: Πιστοποιημένη στο EU-US Data Privacy Framework· επιπρόσθετα καλύπτεται από Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής·`,
            `Resend: Διαβιβάσεις δεδομένων διεπόμενες από Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής·`,
            `Sentry: Διαβιβάσεις δεδομένων διεπόμενες από Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής·`,
            `Cloudflare Turnstile: Δρομολόγηση μέσω παγκόσμιου CDN· διαβιβάσεις δεδομένων διεπόμενες από Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής·`,
            `Anthropic (πάροχος του βοηθού AI Claude): Διαβιβάσεις δεδομένων διεπόμενες από Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής·`,
            `Google (πάροχος του βοηθού AI Gemini): Πιστοποιημένη στο EU-US Data Privacy Framework· επιπρόσθετα καλύπτεται από Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής.`,
          ],
        },
        `Σε κάθε περίπτωση διαβίβασης δεδομένων εκτός ΕΕ/ΕΟΧ, διασφαλίζουμε την ύπαρξη κατάλληλων εγγυήσεων σύμφωνα με το άρθρο 46 του GDPR, περιλαμβανομένων των Τυποποιημένων Συμβατικών Ρητρών που έχουν υιοθετηθεί από την Ευρωπαϊκή Επιτροπή.`,
      ],
    },
    {
      heading: "10. Τα Δικαιώματά σας",
      content: [
        `Βάσει του GDPR, έχετε τα ακόλουθα δικαιώματα σχετικά με τα προσωπικά σας δεδομένα:`,
        {
          type: "list",
          items: [
            `Δικαίωμα Πρόσβασης (Άρθ. 15): Μπορείτε να ζητήσετε αντίγραφο των προσωπικών δεδομένων που διατηρούμε.`,
            `Δικαίωμα Διόρθωσης (Άρθ. 16): Μπορείτε να ζητήσετε τη διόρθωση ανακριβών ή ελλιπών δεδομένων.`,
            `Δικαίωμα Διαγραφής (Άρθ. 17): Μπορείτε να ζητήσετε τη διαγραφή των δεδομένων σας, υπό τις νομικές υποχρεώσεις διατήρησης.`,
            `Δικαίωμα Περιορισμού (Άρθ. 18): Μπορείτε να ζητήσετε τον περιορισμό της επεξεργασίας σε ορισμένες περιπτώσεις.`,
            `Δικαίωμα Φορητότητας (Άρθ. 20): Μπορείτε να ζητήσετε τα δεδομένα σας σε δομημένη, κοινώς χρησιμοποιούμενη μορφή, αναγνώσιμη από μηχανή.`,
            `Δικαίωμα Εναντίωσης (Άρθ. 21): Μπορείτε να αντιταχθείτε στην επεξεργασία βάσει έννομου συμφέροντος.`,
            `Δικαίωμα Ανάκλησης Συγκατάθεσης (Άρθ. 7(3)): Όπου η επεξεργασία βασίζεται σε συγκατάθεση, μπορείτε να την ανακαλέσετε ανά πάσα στιγμή, χωρίς να επηρεάζεται η νομιμότητα της προηγούμενης επεξεργασίας.`,
          ],
        },
        {
          type: "emphasis",
          text: "Άσκηση των Δικαιωμάτων σας",
        },
        `Για την άσκηση οποιουδήποτε εκ των ανωτέρω δικαιωμάτων, μπορείτε να επικοινωνήσετε μαζί μας στο privacy@agapae.gr. Θα απαντήσουμε εντός ενός (1) μηνός, όπως απαιτεί ο GDPR. Η προθεσμία αυτή δύναται να παραταθεί κατά δύο (2) επιπλέον μήνες για ιδιαίτερα πολύπλοκα αιτήματα.`,
        `Δεν θα επιβληθεί τέλος, εκτός εάν το αίτημα είναι προδήλως αβάσιμο ή υπερβολικό.`,
        {
          type: "emphasis",
          text: "Δικαίωμα Υποβολής Καταγγελίας",
        },
        `Εάν πιστεύετε ότι η επεξεργασία των δεδομένων σας παραβιάζει τον GDPR, έχετε δικαίωμα υποβολής καταγγελίας στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ):`,
        {
          type: "list",
          items: [
            `Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ)`,
            `Διεύθυνση: Κηφισίας 1-3, 115 23 Αθήνα`,
            `Ιστοσελίδα: www.dpa.gr`,
            `Τηλέφωνο: +30 210 6475600`,
            `Email: contact@dpa.gr`,
          ],
        },
      ],
    },
    {
      heading: "11. Σχέση Υπεύθυνου και Εκτελούσας την Επεξεργασία",
      content: [
        `Όταν η EnQube ΙΚΕ ενεργεί ως εκτελούσα την επεξεργασία για λογαριασμό Ζευγαριών (ως υπευθύνων επεξεργασίας), σε σχέση με δεδομένα Καλεσμένων και Δεδομένα Εκδήλωσης, οι υποχρεώσεις μας ρυθμίζονται από τις Ενότητες 6 και 7 της παρούσας Πολιτικής, από τους Όρους Χρήσης μας και διέπονται από τις απαιτήσεις του άρθρου 28 του GDPR.`,
        `Στις υποχρεώσεις αυτές περιλαμβάνονται, μεταξύ άλλων, η επεξεργασία αποκλειστικά σύμφωνα με τις τεκμηριωμένες οδηγίες του Ζευγαριού, η τήρηση εμπιστευτικότητας, η εφαρμογή κατάλληλων τεχνικών και οργανωτικών μέτρων ασφαλείας, η συνδρομή στην εκπλήρωση των υποχρεώσεων του υπεύθυνου επεξεργασίας έναντι των υποκειμένων των δεδομένων, καθώς και η διαγραφή ή επιστροφή των δεδομένων κατά τη λήξη της παροχής της Υπηρεσίας.`,
        `Εάν είστε Ζευγάρι και επιθυμείτε να συνάψετε ξεχωριστή, εξατομικευμένη Συμφωνία Επεξεργασίας Δεδομένων (DPA) ή έχετε ερωτήσεις σχετικά με τις ρυθμίσεις της επεξεργασίας, μπορείτε να επικοινωνήσετε μαζί μας στο privacy@agapae.gr.`,
      ],
    },
    {
      heading: "12. Μέτρα Ασφαλείας",
      content: [
        `Εφαρμόζουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των προσωπικών σας δεδομένων:`,
        {
          type: "list",
          items: [
            `Κρυπτογράφηση κατά τη μεταφορά: Όλα τα δεδομένα κρυπτογραφούνται μέσω TLS (Transport Layer Security).`,
            `Κρυπτογράφηση σε αδράνεια: Τα αρχεία πολυμέσων στο AWS S3 και τα δεδομένα στο MongoDB Atlas είναι κρυπτογραφημένα.`,
            `Ασφάλεια κωδικών: Οι κωδικοί πρόσβασης υπόκεινται σε κρυπτογραφική κατακερματοποίηση με τον αλγόριθμο bcrypt και τυχαία κρυπτογραφικά άλατα (salt rounds), και ουδέποτε αποθηκεύονται σε απλό κείμενο.`,
            `Έλεγχος ταυτότητας: Tokens πρόσβασης μικρής διάρκειας (15 λεπτά) με ασφαλή εναλλαγή tokens ανανέωσης (refresh tokens).`,
            `Έλεγχος πρόσβασης: Πρόσβαση βάσει ρόλων· χρήση προσωρινών διαδικτυακών διευθύνσεων με υπογραφή (presigned URLs) για τα πολυμέσα, με λήξη 5 λεπτών.`,
            `Περιορισμός αιτημάτων: Όρια αιτημάτων ανά λειτουργικό σημείο, προσαρμοσμένα στο επίπεδο κινδύνου του καθενός (για παράδειγμα, αυστηρότερα όρια στα σημεία ελέγχου ταυτότητας και επικοινωνίας απ' ό,τι σε διαδρομές μόνο για ανάγνωση), για προστασία από επιθέσεις ωμής βίας (brute force), αυτοματοποιημένη εξόρυξη δεδομένων (scraping) και άλλες μορφές κατάχρησης.`,
            `Καταγραφή ελέγχου: Ολοκληρωμένη καταγραφή γεγονότων ασφαλείας.`,
            `Ασφάλεια υποδομής: Υποδομές επαγγελματικού επιπέδου από τους παρόχους AWS και Google Cloud.`,
          ],
        },
        `Παρότι εφαρμόζουμε ισχυρά μέτρα ασφαλείας, κανένα σύστημα δεν είναι πλήρως απρόσβλητο. Σας ενθαρρύνουμε να χρησιμοποιείτε ισχυρούς, μοναδικούς κωδικούς πρόσβασης.`,
      ],
    },
    {
      heading: "13. Απόρρητο Ανηλίκων",
      content: [
        `Η Πλατφόρμα δεν απευθύνεται σε παιδιά κάτω των δεκαπέντε (15) ετών. Σύμφωνα με το άρθρο 21 του Ν. 4624/2019, σε συνδυασμό με το άρθρο 8 του GDPR, η Ελλάδα έχει ορίσει το όριο ηλικίας για τη συγκατάθεση παιδιού στην επεξεργασία προσωπικών δεδομένων, στο πλαίσιο υπηρεσιών της κοινωνίας της πληροφορίας, στα δεκαπέντε (15) έτη. Δεν συλλέγουμε εν γνώσει μας προσωπικά δεδομένα από παιδιά κάτω των δεκαπέντε (15) ετών. Εάν αντιληφθείτε ότι παιδί κάτω της ηλικίας αυτής μας έχει παράσχει δεδομένα, παρακαλούμε επικοινωνήστε μαζί μας στο privacy@agapae.gr και θα λάβουμε μέτρα για την άμεση διαγραφή τους.`,
        `Σημείωση: Το ελάχιστο όριο των δεκαπέντε (15) ετών που αναφέρεται εδώ αφορά τη νόμιμη επεξεργασία προσωπικών δεδομένων και είναι διακριτό από το συμβατικό όριο των δεκαοκτώ (18) ετών που απαιτείται για τη δημιουργία λογαριασμού και τη σύναψη των Όρων Χρήσης μας.`,
      ],
    },
    {
      heading: "14. Αλλαγές στην Πολιτική Απορρήτου",
      content: [
        `Μπορούμε να ενημερώνουμε αυτή την Πολιτική. Σε περίπτωση ουσιωδών αλλαγών:`,
        {
          type: "list",
          items: [
            `Θα επικαιροποιηθεί η «Ημερομηνία ισχύος» στην αρχή της Πολιτικής·`,
            `Θα ενημερωθούν οι εγγεγραμμένοι χρήστες μέσω email ή μέσω της Πλατφόρμας·`,
            `Οι ουσιώδεις αλλαγές θα τεθούν σε ισχύ τριάντα (30) ημέρες μετά την ειδοποίηση.`,
          ],
        },
        `Σας ενθαρρύνουμε να ελέγχετε περιοδικά αυτή την Πολιτική.`,
      ],
    },
    {
      heading: "15. Επικοινωνία",
      content: [
        `Εάν έχετε ερωτήσεις σχετικά με αυτή την Πολιτική, τα δεδομένα σας ή θέλετε να ασκήσετε τα δικαιώματά σας, επικοινωνήστε μαζί μας:`,
        {
          type: "list",
          items: [
            `Email: privacy@agapae.gr`,
            `Εταιρεία: EnQube ΙΚΕ`,
            `Έδρα: Πάτρα, Ελλάδα`,
          ],
        },
      ],
    },
  ],
};

export default privacyGR;
